<template>
  <div class="content">
    <h5-header :header-msg="headerMsg"></h5-header>

    <div class="state">
      <img src="../../assets/img/pic_warnings.png" alt />
      <p>{{reportMsg.title}}</p>
      <p @click="goOrderDetails(reportMsg.orderId)">
        <span>订单号:{{reportMsg.orderSn}}</span>
        <i class="iconfont icon-home_location_icon_r"></i>
      </p>
    </div>

    <div class="msg">
      <p >
        <span>时间</span>
        <span>{{reportMsg.createTime}}</span>
      </p>
      <p >
        <span>转单原因</span>
        <span>{{reportMsg.reason}}</span>
      </p>
    </div>

    <div class='tels'>
      <span>客服电话</span>
      <span @click="tel">0752-2162293</span>
    </div>

    <a href="tel:0752-2162293" v-show="show" id="tel">0752-2162293</a>
  </div>
</template>

<script>
import { myReportDetails } from "@/api/picker/index";
export default {
  data() {
    return {
      headerMsg: {
        title: "举报详情",
        url: ""
      },
      reportMsg: {}, //举报详情obj
      id: "", //提现纪录id
      show: false,
    };
  },
  mounted() {
    // this.id = this.$route.query.id;
    this.myReportDetails(this.GetQueryString("id"));
  },
  methods: {
    myReportDetails(id) {
      let obj = {
        token: this.$store.getters.token || this.GetQueryString("token"),
        id
      };
      myReportDetails(obj).then(res => {
        if (res.appStatus.errorCode == "0") {
          this.reportMsg = res.content;
          return;
        }
        this.$toast(res.appStatus.message)
      });
    },

    goOrderDetails(id) {
      var ua = window.navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        //微信环境
      } else {
        //非微信环境逻辑
        let u = navigator.userAgent,
          app = navigator.appVersion;
        let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1; //android终端或者uc浏览器
        let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
        let isOS = isAndroid ? true : false;
        if (isOS) {
          // Android环境
          window.Android.goOrderDetails(id);
        } else {
          // ios环境
          window.webkit.messageHandlers.goOrderDetails.postMessage({
            id
          });
        }
      }
    },

    // 拨打电话
    tel() {
      document.getElementById("tel").click();
      // this.$dialog
      //   .confirm({
      //     message: "188-1111-000",
      //     confirmButtonText: "呼叫",
      //     confirmButtonColor: "#EC130C"
      //   })
      //   .then(() => {
      //     // on confirm
      //     console.log(this.$refs.tel.el);
          
      //   })
      //   .catch(() => {
      //     // on cancel
      //   });
    },
  }
};
</script>

<style lang="scss" scoped>
.content {
  p {
    margin: 0;
  }
  .state {
    width: auto;
    height: fit-content;
    margin: 0 12px 20px;
    // border-bottom: 1px solid #f0f0f0;
    img {
      width: 105px;
      height: 105px;
      display: block;
      margin: 50px auto 30px;
    }
    .col {
      color: #ec130c;
    }
    p:nth-child(2) {
      display: inline-block;
      color: #1d1d1d;
      font-size: 17px;
      margin: 0 30px;
    }
    p:nth-child(3) {
      width: 290px;
      height: 61px;
      line-height: 61px;
      padding: 0 10px 0 15px;
      justify-content: space-between;
      color: #ec130c;
      background: rgba(236, 19, 12, 0.1);
      font-size: 17px;
      margin: 25px auto 15px;
      display: flex;
      justify-content: space-between;
    }
  }
  .msg {
    width: 315px;
    height: auto;
    margin: 0 auto;
    text-align: left;
    p {
      width: auto;
      height: 20px;
      line-height: 20px;
      //   padding: 0 12px;
      display: flex;
      font-size: 15px;
      color: #1d1d1d;
      span {
        display: block;
      }
      span:first-child {
        // color: #666;
        margin-right: 5px;
      }
    }
    > p:last-child {
      margin-top: 15px;
    }
  }
  .tels{
    width: auto;
    font-size: 17px;
    position: absolute;
    bottom:25px;
    left: 0;
    right: 0;
    margin: 0 auto;
    span:last-child{
      color: #1030D2;
      padding-left: 5px;
    }
  }
}
</style>

